// eslint-disable-next-line import/no-anonymous-default-export
export default {
    menu: {
        dashboard: {
            name: 'Home'
        },
        policies : {
            name: 'Policen'
        },
        'damage-reports' : {
            name : 'Schäden'
        },
        'claims-managers' : {
            name : 'Claims managers'
        },
        'vat-rates': {
            name: 'VAT Rates'
        }
    }
}